import * as Immutable from 'immutable';

export interface IImageStore {
	id: string
	name: string
	src: string
	fileid: string
	width: number
	height: number
	chunked: boolean
}

const defaultImageStore = Immutable.Record<IImageStore>({
	id: undefined,
	name: undefined,
	src: undefined,
	fileid: undefined,
	width: 0,
	height: 0,
	chunked: false
});

export default class ImageStore extends defaultImageStore implements IImageStore {}